import { useState } from "react";
import { Table, Button, message } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { loading, notLoading } from "../../../features/loading/loadingSlice";
import { selectAccessAuthorization } from "../../../features/login/loginSlice";
import { fetchWithoutResponse } from "../../../utils/EasyFetch";
import { errorNameToMessage } from "../../../utils/ErrorMessages";

interface TaskRow {
  key: string;
  type: string;
}

const RunTasks = () => {
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [runningTask, setRunningTask] = useState<string | null>(null);
  const accessToken = useAppSelector(selectAccessAuthorization);

  const handleRunTask = (taskType: string) => {
    setRunningTask(taskType);
    dispatch(loading());

    fetchWithoutResponse(
      "POST",
      "/tasks",
      { type: taskType },
      "Bearer " + accessToken
    )
      .then(() => {
        dispatch(notLoading());
        setRunningTask(null);
        messageApi.success(`Successfully started ${taskType}`);
      })
      .catch((err: any) => {
        dispatch(notLoading());
        setRunningTask(null);
        messageApi.error(errorNameToMessage(err.name));
      });
  };

  const tasks: TaskRow[] = [
    { key: "1", type: "CACHE_WOW_DATA_TASK" },
    { key: "2", type: "CACHE_WOW_HC_DATA_TASK" },
    { key: "3", type: "CACHE_LOL_DATA_TASK" },
    { key: "4", type: "TOKEN_CLEANUP_TASK" },
    { key: "5", type: "TASK_CLEANUP_TASK" },
    { key: "6", type: "UPDATE_LOL_ENTITIES_TASK" },
    { key: "7", type: "UPDATE_WOW_HARDCORE_GUILDS"},
    { key: "8", type: "UPDATE_MYTHIC_PLUS_SEASON"}
  ];

  const columns = [
    {
      title: "Task Type",
      dataIndex: "type",
      key: "type",
      sorter: (a: TaskRow, b: TaskRow) => a.type.localeCompare(b.type),
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: TaskRow) => (
        <Button
          type="primary"
          icon={<PlayCircleOutlined />}
          loading={runningTask === record.type}
          onClick={() => handleRunTask(record.type)}
        >
          Run
        </Button>
      ),
    },
  ];

  return (
    <div>
      {contextHolder}
      <Table
        dataSource={tasks}
        showHeader={false}
        columns={columns}
        pagination={false}
        bordered={true}
        style={{ margin: "1%" }}
      />
    </div>
  );
};

export default RunTasks;
